import script from "./DeliveryChallanTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryChallanTab.vue?vue&type=script&setup=true&lang=js"

import "./DeliveryChallanTab.vue?vue&type=style&index=0&id=1491ec34&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1491ec34"]])

export default __exports__